import { Container } from "./style";

import LogoSmartfitCoach from "../../assets/img/logo.png";

import { Button } from "../../components/Button";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/Auth";
import { useNavigate, useParams } from "react-router-dom";

import { cpfMask } from "./utils/mask";
import api from "../../services/api";
import { useTranslation } from 'react-i18next';
import LanguageSelector from "../../components/LanguageSelector";

export const Login = () => {
  const [cpfValue, setCpfValue] = useState("");
  const { setToken, isAuthenticated, setIsAuthenticated, error, setError } =
    useAuth();
  
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const { language } = useParams();
  const basePath = language ? `/${language}` : process.env.REACT_APP_LANG;

  const formatDocument = (document) => {
    return document.replaceAll(".", "").replace("-", "");
  };

  const autentication = async (data) => {
    let resp = await api
      .post(`/session`, data, {
        headers: {
          'locale': i18n.language
        }
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });

    if (resp?.response) {
      if (resp?.response.data.error === "invalid_user") {
        setError(t('loginPage.invalidUser'));
      }

      if (resp?.response.data.error === "scheduled" || resp?.response.data.error === "fail_user_locale")  {
        navigate(`${basePath}/error`);
      }

      setIsAuthenticated(false);
    }

    if (resp?.data) {
      setToken(resp.data);
      setError(false);
      setIsAuthenticated(true);
    }
  };

  const schema = yup.object().shape({
    document: yup.string().required("Campo obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmitFunction = (data) => {
    data.document = formatDocument(data.document);

    autentication(data);
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate(`${basePath}/schedule`);
    } else {
      navigate(basePath);
    }
  }, [isAuthenticated]);

  return (
    <>
      <Container>
        <div>
          <figure>
            <img src={LogoSmartfitCoach} alt="Logo Coach" />
          </figure>

          <form onSubmit={handleSubmit(onSubmitFunction)}>
            <h1>{t('loginPage.welcome')}</h1>

            <div>
              <label htmlFor="">{t('loginPage.document')}</label>
              <input
                type="text"
                name="document"
                maxLength={14}
                {...register("document")}
                placeholder={errors && errors.cpf?.message}
                value={cpfMask(cpfValue, i18n.language)}
                onChange={(e) => setCpfValue(e.target.value)}
              />
            </div>

            <Button label={t('loginPage.action').toUpperCase()} type={"submit"} />
          </form>
          {error && <p>{error}</p>}
        </div>

        <footer>
          <figure>
            <img src={LogoSmartfitCoach} alt="logo coach" />
          </figure>
        </footer>

        <LanguageSelector />
      </Container>
    </>
  );
};
